import request from '../../request';
import { isNil } from 'lodash';

// CONSTANTS
import { ENTITY_NAMES_BY_ID, ENTITY_PARENT_APPS } from 'constants/common';

/**
 * Gets a list of views for the specified user
 */
export function query(userId) {
  return request(`common/views/?owner=${userId}`, {
    method: 'GET',
  });
}

/**
 * Creates a new view
 */
export function create(name, rules, columns, owner, typeId) {
  return request('common/views/', {
    method: 'POST',
    data: {
      name,
      rules,
      columns,
      owner,
      type: typeId,
    },
  });
}

/**
 * Updates a view
 */
export function update(id, rules, columns) {
  return request(`common/views/${id}/`, {
    method: 'PATCH',
    data: {
      rules,
      columns,
    },
  });
}

/**
 * Renames a view
 */
export function rename(id, name) {
  return request(`common/views/${id}/`, {
    method: 'PATCH',
    data: {
      name,
    },
  });
}

/**
 * Make a view default
 */
export function toggleDefault(id, isDefault) {
  return request(`common/views/${id}/`, {
    method: 'PATCH',
    data: {
      isDefault,
    },
  });
}

/**
 * Deletes a view
 */
export function destroy(id) {
  return request(`common/views/${id}/`, {
    method: 'DELETE',
  });
}

/**
 * Exports a view
 */
export function processExportView(id, entityTypeId, emails, filters) {
  const params = {
    ...filters,
    viewId: id,
    dest: 'download',
    recipient: undefined,
  };

  const entityName = ENTITY_NAMES_BY_ID[entityTypeId];
  const entityParentApp = ENTITY_PARENT_APPS[entityName];

  const url = `${entityParentApp}/${entityName}/export/`;

  if (emails) {
    params.recipient = emails;
    params.dest = 'email';
  }

  return request(url, {
    method: 'GET',
    params,
  });
}

/**
 * Gets the recurring email reports
 */
export function getRecurringEmails() {
  return request('common/reports/', {
    method: 'GET',
  });
}

/**
 * Updates or creates a recurring email
 */
export function saveRecurringEmail(recurringEmail, id) {
  const url = `common/reports/${!isNil(id) ? `${id}/` : ''}`;
  const method = !isNil(id) ? 'PATCH' : 'POST';

  return request(url, {
    method,
    data: recurringEmail,
  });
}

/**
 * Deletes a recurring email
 */
export function removeRecurringEmail(id) {
  return request(`common/reports/${id}/`, {
    method: 'DELETE',
  });
}
